import { useRemoteClientPost } from '../../../../../configs/http-client'
import { useLocalStorage } from '../../../../../remote/local-storage'
import { useToast } from '../../../../hooks'

export const createTemplate = async (data: any) => {
  const { getUnitId } = useLocalStorage()
  const { httpClientPost } = useRemoteClientPost()
  const { showToast } = useToast()
  try {
    await httpClientPost('/contratos', {
      ...data,
      unidade: {
        id: getUnitId()
      }
    })
    showToast('Template criado', 'success')
  } catch (error) {
    console.log(error)
    showToast('Erro ao criar o template', 'error')
  }
}
